import IHcValidationResult from './IHcValidationResult';

export default class HcValidationResult implements IHcValidationResult {
    
    public isValid: boolean = true;
    public message: string = '';

}